import React from "react";
import "../components/AdminLayout.css";

// Generic stub for admin pages that follow the same CRUD pattern as Projects.
// Replace each stub with a full CRUD page by copying AdminProjects.js
// and changing the endpoint, form fields, and table columns.

const AdminStub = ({ title, endpoint, description }) => {
  return (
    <div>
      <div className="adm-page-header">
        <div>
          <h1 className="adm-page-title">{title}</h1>
          <p className="adm-page-sub">{description}</p>
        </div>
        <button className="adm-add-btn" disabled style={{ opacity: 0.5 }}>
          <i className="fa-solid fa-plus"></i>
          Add {title.replace(/s$/, "")}
        </button>
      </div>

      <div className="adm-card" style={{ textAlign: "center", padding: "3rem" }}>
        <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🚧</div>
        <h3 style={{ fontFamily: "'Syne',sans-serif", color: "var(--adm-text)", marginBottom: "0.5rem" }}>
          Coming Soon
        </h3>
        <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.875rem", maxWidth: 360, margin: "0 auto", lineHeight: 1.7 }}>
          This module is ready to build. Copy <code style={{ color: "#0a9b7c" }}>AdminProjects.js</code> and replace
          the endpoint with <code style={{ color: "#0a9b7c" }}>{endpoint}</code> to create this CRUD panel.
        </p>

        <div style={{
          display: "inline-block",
          marginTop: "1.5rem",
          padding: "1rem 1.5rem",
          background: "rgba(10,107,90,0.08)",
          border: "1px solid rgba(10,107,90,0.2)",
          borderRadius: "10px",
          fontFamily: "monospace",
          fontSize: "0.8rem",
          color: "#0a9b7c",
          textAlign: "left",
        }}>
          API Endpoint: <strong>{endpoint}</strong><br/>
          Methods: GET / POST / PATCH / DELETE
        </div>
      </div>
    </div>
  );
};

// ── Individual stub pages ────────────────────────────────────────────────────

export const AdminServices = () => (
  <AdminStub
    title="Services"
    endpoint="http://localhost:5000/services"
    description="Manage the services shown on the Services page"
  />
);

export const AdminTeam = () => (
  <AdminStub
    title="Team Members"
    endpoint="http://localhost:5000/team-members"
    description="Manage team members shown on the Team page"
  />
);

export const AdminTestimonials = () => (
  <AdminStub
    title="Testimonials"
    endpoint="http://localhost:5000/testimonials"
    description="Manage client testimonials"
  />
);

export const AdminTech = () => (
  <AdminStub
    title="Tech Stack"
    endpoint="http://localhost:5000/technologies"
    description="Manage technologies shown on the Tech Stack page"
  />
);

export const AdminPricing = () => (
  <AdminStub
    title="Pricing Plans"
    endpoint="http://localhost:5000/pricing"
    description="Manage pricing tiers and features"
  />
);

export const AdminContent = () => (
  <AdminStub
    title="Hero / Content"
    endpoint="http://localhost:5000/hero"
    description="Edit homepage hero text, stats, and CTA buttons"
  />
);

export const AdminSettings = () => (
  <div>
    <div className="adm-page-header">
      <div>
        <h1 className="adm-page-title">Settings</h1>
        <p className="adm-page-sub">Platform configuration</p>
      </div>
    </div>
    <div className="adm-card">
      <h3 style={{ fontFamily: "'Syne',sans-serif", color: "var(--adm-text)", marginBottom: "1.5rem", fontSize: "0.95rem" }}>
        API Configuration
      </h3>
      <div className="adm-form">
        <div className="adm-form-field">
          <label className="adm-form-label">Backend URL</label>
          <input className="adm-form-input" defaultValue="http://localhost:5000" disabled />
        </div>
        <div className="adm-form-field">
          <label className="adm-form-label">Frontend URL</label>
          <input className="adm-form-input" defaultValue="http://localhost:3000" disabled />
        </div>
      </div>
      <p style={{ color: "rgba(255,255,255,0.3)", fontSize: "0.8rem", marginTop: "1rem" }}>
        To change the API URL, edit <code style={{ color: "#0a9b7c" }}>src/api/api.js</code>
      </p>
    </div>
  </div>
);

export default AdminStub;
